import { Stack, useBreakpointValue, FormControl, FormLabel, HStack, IconButton } from '@chakra-ui/react'
import * as React from 'react'
import { IBaseDrawerProps } from '../BaseDrawer';
import { Field, FieldProps, FormikProps } from 'formik';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';
import { InputFormControl } from '../../formcontrols/InputFormControl';
import { IApiProjectOptionObserver } from '../../../models/api/project/options/IApiProjectOptionObserver';
import { ContactSearch } from '../../ContactSearch/ContactSearch';
import { ContactSearchResult } from '../../ContactSearch/ContactSearchResult';
import { FiEdit2 } from 'react-icons/fi';

export interface IEditObserverDrawerProps extends Omit<IBaseDrawerProps<IApiProjectOptionObserver>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText" | "isOpen"> {
    defaultValue: IApiProjectOptionObserver | undefined;
}

export const EditObserverDrawer = (props: IEditObserverDrawerProps) => {
    return (
        <BaseDrawerWithForm
            isOpen={props.defaultValue !== undefined}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue}
            headerText="Beobachter bearbeiten"
        >
            {({ handleSubmit, errors, touched, isSubmitting, setFieldValue }: FormikProps<IApiProjectOptionObserver>) => (
                <Stack px="0" spacing="4">
                    <FormControl>
                        <FormLabel htmlFor="contact">Kontakt</FormLabel>
                        <Field name="contact" validate={(value: any) => (value === undefined) ? "Kontakt ist erforderlich!" : undefined}>
                            {({ meta: { value } }: FieldProps) => (
                                <ContactSearchResult contact={value} />
                            )}
                        </Field>                        
                    </FormControl>
                    <InputFormControl 
                        field="role"
                        label="Rolle (optional)"
                        isInvalid={(errors.role && touched.role) ? true : false}
                        isDisabled={isSubmitting}
                        errorMessage={errors.role}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}